import { PassengerTripsPage } from './features/passenger-trips-page/passenger-trips-page';
import { canActivateAuthRole } from './core/auth-guard-guard';
import { ConnectAccount } from './features/connect-account/connect-account';
import { HomePage } from './features/home-page/home-page';
import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./features/start-page/start-page').then((m) => m.StartPage),
  },
  {
    path: 'home',
    canActivate: [canActivateAuthRole],
    loadComponent: () =>
      import('./features/home-page/home-page').then((m) => m.HomePage),
  },
  {
    path: 'connect/:id',
    loadComponent: () =>
      import('./features/connect-page/connect-page').then((m) => m.ConnectPage),
  },
  {
    path: 'connectAccount/:id',
    loadComponent: () =>
      import('./features/connect-account/connect-account').then(
        (m) => m.ConnectAccount
      ),
  },
  {
    path: 'passenger/:id',
    canActivate: [canActivateAuthRole],
    loadComponent: () =>
      import('./features/passenger-trips-page/passenger-trips-page').then(
        (m) => m.PassengerTripsPage
      ),
  },
  {
    path: 'contact',
    canActivate: [canActivateAuthRole],
    loadComponent: () =>
      import('./features/contact-page/contact-page').then(
        (m) => m.ContactPage
      ),
  },
];
